export default __webpack_public_path__ + "static/media/sun.9bae88fd.svg";